






import { Vue, Component } from "vue-property-decorator";
import { ContractsModule } from "@/store/contracts.module";

@Component
export default class InfoQuestionaryFooter extends Vue {
  get text() {
    return this.$t("questionnaire.notice").toString();
  }

  showQuestionare() {
    ContractsModule.setshowQuestionnaire(true);
  }
}
